import { Shield, CreditCard, Lock, Heart, Sparkles } from "lucide-react";

export const TrustBadges = () => {
  const badges = [
    { icon: CreditCard, text: "Simple Pricing", subtext: "From £3.99" },
    { icon: Shield, text: "No Subscriptions", subtext: "One-time 60 day access" },
    { icon: Lock, text: "Secure Checkout", subtext: "Stripe protected" },
    { icon: Heart, text: "Loved by Families", subtext: "Everywhere" },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4">
      {badges.map((badge, index) => (
        <div
          key={index}
          className="card-glass-dark group relative flex flex-col items-center text-center p-4 sm:p-6 rounded-xl sm:rounded-2xl hover:border-primary/30 transition-all duration-300 ease-premium hover:-translate-y-1"
          style={{ animationDelay: `${index * 100}ms` }}
        >
          <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-gold/5 rounded-xl sm:rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
          <div className="relative w-10 h-10 sm:w-14 sm:h-14 rounded-xl sm:rounded-2xl bg-gradient-to-br from-primary/20 to-accent/15 flex items-center justify-center mb-2 sm:mb-3 group-hover:scale-110 transition-transform duration-300 border border-primary/20">
            <badge.icon className="w-4 h-4 sm:w-6 sm:h-6 text-primary" />
          </div>
          <p className="relative font-semibold text-foreground text-xs sm:text-sm tracking-tight">{badge.text}</p>
          <p className="relative text-[10px] sm:text-xs text-muted-foreground mt-0.5 sm:mt-1">{badge.subtext}</p>
        </div>
      ))}
    </div>
  );
};
